import { BotMessageBubble } from "./BotMessageBubble";
import { UserMessageBubble } from "./UserMessageBubble";
import { IMessage } from "../types";

interface IMessageListProps {
  messages: IMessage[];
}

const MessageList = ({ messages }: IMessageListProps) => {
  const extract_text = (message: IMessage): string => {
    if (typeof message.content == "string") {
      return message.content;
    }
    if (typeof message.content === "undefined") {
      return "";
    }
    return message.content[0]["text"];
  };

  const extract_image = (message: IMessage) => {
    if (typeof message.content == "string") {
      return null;
    }
    if (typeof message.content === "undefined") {
      return null;
    }
    return message.content[1]["image_url"]["url"];
  };

  return (
    <>
      {messages.map((message) =>
        message.role === "assistant" ? (
          <BotMessageBubble
            key={`bot_${message.date_time}`}
            markdownText={extract_text(message)}
            references={message.references}
            date_time={message.date_time}
          />
        ) : (
          <UserMessageBubble
            key={message.date_time}
            markdownText={extract_text(message)}
            image_source={extract_image(message)}
            date_time={message.date_time}
          />
        ),
      )}
    </>
  );
};

export { MessageList };
